import React, { useEffect, useRef } from "react";

export const VoiceVisualization = ({ isActive }) => {
	const canvasRef = useRef(null);
	const animationRef = useRef(null);

	useEffect(() => {
		const canvas = canvasRef.current;
		const ctx = canvas.getContext("2d");
		let bars = [];

		const initBars = () => {
			const barCount = 30;
			bars = Array(barCount)
				.fill()
				.map(() => ({
					height: Math.random() * 40 + 15,
					speed: Math.random() * 0.5 + 0.3,
				}));
		};

		const resizeCanvas = () => {
			canvas.width = canvas.offsetWidth;
			canvas.height = canvas.offsetHeight;
		};

		const drawBars = () => {
			ctx.clearRect(0, 0, canvas.width, canvas.height);

			const gradient = ctx.createLinearGradient(0, canvas.height, 0, 0);
			gradient.addColorStop(0, "#3B82F6"); // blue-500
			gradient.addColorStop(1, "#8B5CF6"); // purple-500

			const barWidth = canvas.width / (bars.length * 2);
			const opacity = isActive ? 0.8 : 0.3;

			bars.forEach((bar, index) => {
				const x = index * barWidth * 2;
				ctx.fillStyle = gradient;
				ctx.globalAlpha = opacity;
				ctx.fillRect(
					x,
					canvas.height - bar.height,
					barWidth,
					bar.height
				);

				if (isActive) {
					bar.height += bar.speed;
					if (bar.height > 55 || bar.height < 15) {
						bar.speed = -bar.speed;
					}
				}
			});

			animationRef.current = requestAnimationFrame(drawBars);
		};

		initBars();
		resizeCanvas();
		drawBars();

		window.addEventListener("resize", resizeCanvas);

		return () => {
			cancelAnimationFrame(animationRef.current);
			window.removeEventListener("resize", resizeCanvas);
		};
	}, [isActive]);

	return (
		<canvas
			ref={canvasRef}
			className="w-full h-full"
			style={{
				filter: isActive
					? "drop-shadow(0 0 10px rgba(59, 130, 246, 0.5))"
					: "none",
			}}
		/>
	);
};
